module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_c('table', {
    staticClass: "table table-sm table-bordered"
  }, [_vm._m(2, false, false), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("BTC")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.abs('BTC', '3h')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.abs('BTC', '12h')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.abs('BTC', '1d')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.abs('BTC', '3d')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.abs('BTC', '7d')))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("BCH")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.abs('BCH', '3h')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.abs('BCH', '12h')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.abs('BCH', '1d')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.abs('BCH', '3d')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.abs('BCH', '7d')))])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n        Absolute hashrate in exahashes per second ("), _c('u', [_vm._v("12h averages")]), _vm._v(").\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "512px",
      "width": "100%"
    }
  }, [_c('canvas', {
    staticStyle: {
      "height": "512px"
    },
    attrs: {
      "id": "canvas-hashrateabs"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticClass: "thead-dark"
  }, [_c('tr', [_c('th', [_vm._v("Coin")]), _vm._v(" "), _c('th', [_vm._v("3h")]), _vm._v(" "), _c('th', [_vm._v("12h")]), _vm._v(" "), _c('th', [_vm._v("1d")]), _vm._v(" "), _c('th', [_vm._v("3d")]), _vm._v(" "), _c('th', [_vm._v("7d")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d90759f","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/charts/hashrateabs.vue
// module id = 528
// module chunks = 1